<template>
  <card-minimal class="gray-subtitle key-advanced-card" :subtitle="label" :subtitleIcon="icon" :tooltip="tooltip">
    <div class="key-advanced">
      <div class="total">
        <span>{{ renameTotal || 'Total' }}</span>
        <p>
          {{ displayTotal }}
          <template v-if="totalAgainst !== false">
            <span style="font-size: 12px; color: green">{{ parseFloat((total / totalAgainst) * 100).toFixed(1) }}%</span>
          </template>
        </p>
      </div>
      <div class="split" v-if="!hideLive || !hideRecorded">
        <div v-if="!hideLive">
          <span>{{ renameLive || 'Live' }}</span>
          <p>
            {{ displayLive }}
            <template v-if="showLiveRecordedPercentage">
              <span style="font-size: 12px; color: green">{{ parseFloat((live / total) * 100).toFixed(1) }}%</span>
            </template>
          </p>
        </div>
        <div v-if="!hideRecorded">
          <span>{{ renameRecorded || 'Rec.' }}'</span>
          <p>
            {{ displayRecorded }}
            <template v-if="showLiveRecordedPercentage">
              <span style="font-size: 12px; color: green">{{ parseFloat((recorded / total) * 100).toFixed(1) }}%</span>
            </template>
          </p>
        </div>
      </div>
    </div>
  </card-minimal>
</template>

<script>

const NUMBER_SPEED = 200;

export default {
  props: {
    label: {
      type: String,
    },
    icon: {
      type: String,
    },
    total: {
      type: Number,
      default: 0,
    },
    totalAgainst: {
      // eslint-disable-next-line
      type: Number|Boolean,
      default: false,
    },
    live: {
      type: Number,
      default: 0,
    },
    recorded: {
      type: Number,
      default: 0,
    },
    renameTotal: {
      type: String,
      default: null,
    },
    renameLive: {
      type: String,
      default: null,
    },
    renameRecorded: {
      type: String,
      default: null,
    },
    hideLive: {
      type: Boolean,
      default: false,
    },
    hideRecorded: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    showLiveRecordedPercentage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    animateNumberUp(from, to) {
      const value = this[from];
      const data = this[to];
      const time = value / NUMBER_SPEED;

      if (data < value) {
        this[to] = Math.ceil(data + time);
        setTimeout(this.animateNumberUp.bind(null, from, to), 1);
      } else {
        this[to] = this[from];
      }
    },
    animateNumberDown(from, to) {
      const value = this[from];
      const data = this[to];
      const time = data / NUMBER_SPEED;

      if (data > value) {
        this[to] = Math.ceil(data - time);
        setTimeout(this.animateNumberDown.bind(null, from, to), 1);
      } else {
        this[to] = this[from];
      }
    },
    startAnimation() {
      if (this.total > this.displayTotal) {
        this.animateNumberUp('total', 'displayTotal');
        this.animateNumberUp('live', 'displayLive');
        this.animateNumberUp('recorded', 'displayRecorded');
      } else {
        this.animateNumberDown('total', 'displayTotal');
        this.animateNumberDown('live', 'displayLive');
        this.animateNumberDown('recorded', 'displayRecorded');
      }
    },
  },
  data() {
    return {
      displayTotal: 0,
      displayLive: 0,
      displayRecorded: 0,
    };
  },
  watch: {
    total() {
      setTimeout(() => {
        this.startAnimation();
      }, 500);
    },
    live() {
      setTimeout(() => {
        this.startAnimation();
      }, 500);
    },
    recorded() {
      setTimeout(() => {
        this.startAnimation();
      }, 500);
    },
  },
  mounted() {
    setTimeout(() => {
      this.startAnimation();
    }, 500);
  },
};
</script>

<style lang="scss">
.key-advanced-card {
  display: flex;

  .card-content {
    flex: 1;
  }
}
.key-advanced {
  padding: 5px 20px 0;

  span {
    color: rgb(137, 137, 137);
    font-size: 12px;
    font-weight: 500;
  }

  .total {
    align-items: center;
    display: flex;
    padding-bottom: 15px;

    p {
      margin-left: 15px;
      font-size: 32px;
      font-weight: 600;
      line-height: 1;

      @media (min-width: 768px) {
        font-size: 42px;
      }
    }
  }

  .split {
    border-top: 1px solid #EEF0F9;
    display: block;
    padding: 10px 0 15px;

    & > * {
      display: flex;
    }

    p {
      font-size: 16px;
      font-weight: 600;
      margin-left: 10px;
    }

    @media (min-width: 768px) {
      display: flex;

      & > * {
        &:not(:first-child) {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
